<template>
  <ul class="list">
    <template v-for="(item, index) in socialitesClone">
      <!-- 如果是编辑状态 -->
      <template v-if="editing">
        <li class="item" :key="index">
          <!-- research gate -->
          <template v-if="item.name == 'research_gate'">
            <el-popover
              ref="popover-research-gate"
              placement="bottom"
              title="请输入你的 research gate 链接地址"
              :width="width"
              trigger="click"
              popper-class="social-popover"
              v-model="visibleResearchGate"
              @hide="hide">
              <el-input v-model="item.url" placeholder="https://"></el-input>
              <div class="foot">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
              </div>
            </el-popover>
            <div v-popover:popover-research-gate>
              <template v-if="item.url">
                <i class="iconfont icon--researchgate el-button--text"
                  :style="{'color': backgroundUrl ?'#fff':''}"></i>
              </template>
              <template v-else>
                <el-tooltip effect="dark" content="设置链接" placement="top">
                  <i class="iconfont icon--researchgate"
                    :style="{'color': backgroundUrl ?'#fff':''}"></i>
                </el-tooltip>
              </template>
            </div>
          </template>

          <!-- google -->
          <template v-if="item.name == 'google'">
            <el-popover
              ref="popover-google"
              placement="bottom"
              title="请输入你的 google 链接地址"
              :width="width"
              trigger="click"
              popper-class="social-popover"
              v-model="visibleGoogle"
              @hide="hide">
              <el-input v-model="item.url" placeholder="https://"></el-input>
              <div class="foot">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
              </div>
            </el-popover>
            <div v-popover:popover-google>
              <template v-if="item.url">
                <i class="iconfont icon--googlescholar el-button--text"
                :style="{'color': backgroundUrl ?'#fff':''}"></i>
              </template>
              <template v-else>
                <el-tooltip effect="dark" content="设置链接" placement="top">
                  <i class="iconfont icon--googlescholar"
                  :style="{'color': backgroundUrl ?'#fff':''}"></i>
                </el-tooltip>
              </template>
            </div>
          </template>

          <!-- facebook -->
          <template v-if="item.name == 'facebook'">
            <el-popover
              ref="popover-facebook"
              placement="bottom"
              title="请输入你的 facebook 链接地址"
              :width="width"
              trigger="click"
              popper-class="social-popover"
              v-model="visibleFacebook"
              @hide="hide">
              <el-input v-model="item.url" placeholder="https://"></el-input>
              <div class="foot">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
              </div>
            </el-popover>
            <div v-popover:popover-facebook>
              <template v-if="item.url">
                <i class="iconfont icon--facebook el-button--text"
                :style="{'color': backgroundUrl ?'#fff':''}"></i>
              </template>
              <template v-else>
                <el-tooltip effect="dark" content="设置链接" placement="top">
                  <i class="iconfont icon--facebook"
                  :style="{'color': backgroundUrl ?'#fff':''}"></i>
                </el-tooltip>
              </template>
            </div>
          </template>

          <!-- linked in -->
          <template v-if="item.name == 'linked_in'">
            <el-popover
              ref="popover-linked-in"
              placement="bottom"
              title="请输入你的 linked in 链接地址"
              :width="width"
              trigger="click"
              popper-class="social-popover"
              v-model="visibleLinkedIn"
              @hide="hide">
              <el-input v-model="item.url" placeholder="https://"></el-input>
              <div class="foot">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
              </div>
            </el-popover>
            <div v-popover:popover-linked-in>
              <template v-if="item.url">
                <i class="iconfont icon--linkedin el-button--text"
                :style="{'color': backgroundUrl ?'#fff':''}"></i>
              </template>
              <template v-else>
                <el-tooltip effect="dark" content="设置链接" placement="top">
                  <i class="iconfont icon--linkedin"
                  :style="{'color': backgroundUrl ?'#fff':''}"></i>
                </el-tooltip>
              </template>
            </div>
          </template>

          <!-- wechat -->
          <template v-if="item.name == 'wechat'">
            <el-popover
              ref="popover-wechat"
              placement="bottom"
              title="配置你的微信公众号"
              :width="width"
              trigger="click"
              popper-class="social-popover"
              v-model="visibleWechat"
              :key="index + 'editing'"
              @hide="hide">
              <el-input v-model="item.des" placeholder="输入你的公众号账号"></el-input>
              <div class="qrcode-wrap">
                <template v-if="item.url">
                  <img :src="item.url" alt="">
                  <el-button type="text" size="small">
                    重新上传
                    <input type="file" accept="image/png, image/jpeg, image/jpg" @change="updateQrcode">
                  </el-button>
                </template>
                <template v-else>
                  <img :src="item.url" alt="">
                  <el-button plain class="absolute" type="primary" >
                    上传公众号二维码
                    <input id="input-uploadWxImg" type="file" accept="image/png, image/jpeg, image/jpg" @change="updateQrcode">
                  </el-button>
                </template>
              </div>
              <div class="foot">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
              </div>
            </el-popover>
            <div v-popover:popover-wechat>
              <template v-if="item.url">
                <i class="iconfont icon--wechat el-button--text"
                :style="{'color': backgroundUrl ?'#fff':''}"></i>
              </template>
              <template v-else>
                <el-tooltip effect="dark" content="设置链接" placement="top">
                  <i class="iconfont icon--wechat"
                  :style="{'color': backgroundUrl ?'#fff':''}"></i>
                </el-tooltip>
              </template>
            </div>
          </template>

          <!-- weibo -->
          <template v-if="item.name == 'weibo'">
            <el-popover
              ref="popover-weibo"
              placement="bottom"
              title="请输入你的 weibo 链接地址"
              :width="width"
              trigger="click"
              popper-class="social-popover"
              v-model="visibleWeibo"
              @hide="hide">
              <el-input v-model="item.url" placeholder="https://"></el-input>
              <div class="foot">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
              </div>
            </el-popover>
            <div v-popover:popover-weibo>
              <template v-if="item.url">
                <i class="iconfont icon--weibo el-button--text"
                :style="{'color': backgroundUrl ?'#fff':''}"></i>
              </template>
              <template v-else>
                <el-tooltip effect="dark" content="设置链接" placement="top">
                  <i class="iconfont icon--weibo"
                  :style="{'color': backgroundUrl ?'#fff':''}"></i>
                </el-tooltip>
              </template>
            </div>
          </template>
        </li>
      </template>

      <!-- 非编辑状态 -->
      <template v-else>
        <!-- research gate -->
          <template v-if="item.name == 'research_gate' && item.url">
            <li class="item" :key="index">
              <a :href="item.url" target="_blank">
                <i class="iconfont icon--researchgate el-button--text"
                :style="{'color': backgroundUrl ?'#fff':''}"></i>
              </a>
            </li>
          </template>

        <!-- google -->
          <template v-if="item.name == 'google' && item.url">
            <li class="item" :key="index">
              <a :href="item.url" target="_blank">
                <i class="iconfont icon--googlescholar el-button--text"
                :style="{'color': backgroundUrl ?'#fff':''}"></i>
              </a>
            </li>
          </template>

        <!-- facebook -->
          <template v-if="item.name == 'facebook' && item.url">
            <li class="item" :key="index">
              <a :href="item.url" target="_blank">
                <i class="iconfont icon--facebook el-button--text"
                :style="{'color': backgroundUrl ?'#fff':''}"></i>
              </a>
            </li>
          </template>

        <!-- linked in -->
          <template v-if="item.name == 'linked_in' && item.url">
            <li class="item" :key="index">
              <a :href="item.url" target="_blank">
                <i class="iconfont icon--linkedin el-button--text"
                :style="{'color': backgroundUrl ?'#fff':''}"></i>
              </a>
            </li>
          </template>

        <!-- wechat -->
          <template v-if="item.name == 'wechat' && item.url">
            <li class="item" :key="index">
              <el-popover
                placement="bottom"
                width="250"
                trigger="hover"
                popper-class="social-popover-wechat"
                :key="index + 'browse'">
                <div class="qrcode-wrap">
                  <p class="title">关注 {{name}} 的公众号</p>
                  <img :src="item.url" alt="">
                  <div class="foot">
                    <p>使用微信扫码关注{{name}}的<br>微信公众号或搜索{{item.des}}</p>
                  </div>
                </div>
                <i class="iconfont icon--wechat el-button--text"
                slot="reference" :style="{'color': backgroundUrl ?'#fff':''}"></i>
              </el-popover>
            </li>
          </template>

        <!-- weibo -->
          <template v-if="item.name == 'weibo' && item.url">
            <li class="item" :key="index">
              <a :href="item.url" target="_blank">
                <i class="iconfont icon--weibo el-button--text"
                :style="{'color': backgroundUrl ?'#fff':''}"></i>
              </a>
            </li>
          </template>
      </template>
    </template>
  </ul>
</template>
<script>
import ImageUtil from '@/utils/image'
import Validate from '@/utils/validate'
export default {
  props: {
    socialites: Array,
    editing: Boolean,
    name: String,
    id: Number,
    isMobile: Boolean,
    backgroundUrl: Boolean
  },
  data () {
    return {
      visibleResearchGate: false,
      visibleGoogle: false,
      visibleLinkedIn: false,
      visibleFacebook: false,
      visibleWechat: false,
      visibleWeibo: false,
      socialitesClone: JSON.parse(JSON.stringify(this.socialites)),
      legal: true,
      width: this.isMobile ? 320 : 390
    }
  },
  methods: {
    cancel () {
      // 更新 socialitesClone
      this.socialitesClone = JSON.parse(JSON.stringify(this.socialites))
      this.visibleResearchGate = false
      this.visibleGoogle = false
      this.visibleLinkedIn = false
      this.visibleFacebook = false
      this.visibleWechat = false
      this.visibleWeibo = false
    },
    hide () {
      this.socialitesClone = JSON.parse(JSON.stringify(this.socialites))
    },
    save () {
      // 更新 socialites
      // 判断链接是否合法
      this.legal = true
      this.socialitesClone.forEach((item, index) => {
        if (item.name !== 'wechat') {
          if (item.url) {
            if (!Validate.isValid('link', item.url)) {
              this.legal = false
              this.$message.error('链接格式不正确')
            }
          }
        }
      })
      if (this.legal) {
        this.$emit('update', this.socialitesClone)
        this.visibleResearchGate = false
        this.visibleGoogle = false
        this.visibleLinkedIn = false
        this.visibleFacebook = false
        this.visibleWechat = false
        this.visibleWeibo = false
      }
    },
    updateQrcode (e) {
      let file = e.target.files[0]
      let url = ImageUtil.getObjectURL(file)
      let name = ImageUtil.getCDNName(url, 200, 200, file.size, file.type)
      let imgname = `acagrid/usercontent/homepage/${this.id}/qrcode/${name}`
      let imgurl = `https://img.okay.do/acagrid/usercontent/homepage/${this.id}/qrcode/${name}`
      ImageUtil.uploadImg(file, imgname, () => {
        // 更新 wechat url 的地址
        this.socialitesClone.forEach((item) => {
          if (item.name === 'wechat') {
            item.url = imgurl
          }
        })
      })
    },
    handleUpload () {
      document.querySelector('#input-uploadWxImg').click()
    }
  }
}
</script>
<style scoped lang="scss">
  @import './index.scss';
</style>
<style lang="scss">
  .social-popover {
    .el-popover__title {
      font-size: 14px;
      color: #606266;
    }
    .foot {
      margin-top: 48px;
      text-align: right;
    }
    .qrcode-wrap {
      width: 220px;
      margin: 16px auto 0;
      text-align: center;
      position: relative;
      img {
        width: 220px;
        height: 220px;
        display: block;
        border: 1px solid #EBEEF5;
      }
      button {
        position: relative;
        input {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          width: 100%;
          opacity: 0;
        }
      }
      .absolute {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
  .social-popover-wechat {
    padding: 12px 0 0 !important;
    .title {
      text-align: center;
    }
    img {
      width: 160px;
      height: 160px;
      display: block;
      margin: 0 auto;
    }
    .foot {
      margin-top: 10px;
      height: 75px;
      border: 1px solid #EBEEF5;
      background-color: #F9FAFC;
      text-align: center;
      display: table;
      width: 100%;
      p {
        display: table-cell;
        vertical-align: middle;
        word-break: break-word;
        padding: 0 15px;
      }
    }
  }
  .social-popover[aria-hidden="false"] {
    z-index: 2000 !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Index/Social/index.vue